import i18n from 'i18next'
import Backend from 'i18next-chained-backend'
import Locize from 'i18next-locize-backend' // load from service
import HttpApi from 'i18next-http-backend' // have a own http fallback
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import { config } from '@config'
import { parseResourceLanguageKey } from '@utils/object-utils'
import { DefaultConfig } from '@constants'

const locizeOptions = {
  projectId: config.localization.locize.projectId,
  apiKey: config.localization.locize.apiKey,
  version:
    config.localization.locize.version || DefaultConfig.LOCALIZATION_LOCIZE_VERSION,
  private:
    (config.localization.locize.private || DefaultConfig.LOCALIZATION_LOCIZE_PRIVATE) ===
    'true',
  referenceLng:
    config.localization.locize.referenceLng ||
    DefaultConfig.LOCALIZATION_LOCIZE_REF_LANGUAGE,
  saveMissing:
    (config.localization.locize.saveMissing ||
      DefaultConfig.LOCALIZATION_SAVE_MISSING) === 'true'
}

type resourcesType = {
  [key: string]: {
    [key: string]: any
  }
}

export const resources: resourcesType = {
  en: { translation: require('../resources/locales/en/translations.json') },
  fr: { translation: require('../resources/locales/fr/translations.json') },
  it: { translation: require('../resources/locales/it/translations.json') },
  ko: { translation: require('../resources/locales/ko/translations.json') },
  ja: { translation: require('../resources/locales/ja/translations.json') },
  'zh-chs': { translation: require('../resources/locales/zh/translations.json') }
}

const parsedKeysResources: resourcesType = {}
Object.keys(resources).forEach(item => {
  parsedKeysResources[parseResourceLanguageKey(item)] = resources[item]
})

const currentLanguage =
  localStorage.getItem('i18nextLng') ||
  config.localization.defaultLanguage ||
  DefaultConfig.LOCALIZATION_DEFAULT_LANGUAGE

const backend = {
  backends: [],
  backendOptions: []
}

switch (config.localization.source || DefaultConfig.LOCALIZATION_SOURCE) {
  // locize backend is used Pre Production Release by Development Team
  case 'locize':
    backend.backends.push(Locize)
    backend.backendOptions.push(locizeOptions)
    break
  // http backend is used for Post Production Release by Services Team
  case 'local':
    backend.backends.push(HttpApi)
    backend.backendOptions.push({
      loadPath: `${config.buyingBoardServiceRestEndpoint}core/localization/content/{{lng}}`
      // addPath: `${config.buyingBoardServiceRestEndpoint}core/localization/content/{{lng}}`,
      // customHeaders: () => ({
      //   authorization: `Bearer ${storage.getItem('access_token')}`
      // })
    })
    break
  default:
}

i18n
  .use(Backend)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    partialBundledLanguages: true,
    fallbackLng: parseResourceLanguageKey(
      config.localization.fallbackLanguage || DefaultConfig.LOCALIZATION_FALLBACK_LANGUAGE
    ),
    lng: parseResourceLanguageKey(currentLanguage),
    debug: true,
    defaultNS:
      config.localization.defaultNamespace ||
      DefaultConfig.LOCALIZATION_DEFAULT_NAMESPACE,
    fallbackNS:
      config.localization.fallbackNamespace ||
      DefaultConfig.LOCALIZATION_FALLBACK_NAMESPACE,
    interpolation: {
      escapeValue: false // escape not needed for react as it escapes by default
    },
    saveMissing: locizeOptions && locizeOptions['saveMissing'] ? true : false,
    backend: backend,
    resources: parsedKeysResources
  })

export default i18n
